export { DocsSearchService } from './services/docs-search';
export { SearchPartitionSyncService } from './services/search-partition-sync';
export {
  classifyBlockSourceType,
  isSearchSourceType,
  type SearchSourceType,
} from './services/search-source';
export { type SearchSourcePlan } from './services/search-source-plan';
export {
  type AttachmentNavigation,
  buildDocsSearchNavigation,
  createDocsSearchNavigationResolvers,
  type DocNavigation,
  type DocsBlockPayload,
  type DocsPayload,
  type DocsPdfPagePayload,
  type DocsSearchBlockStatus,
  type DocsSearchNavigablePayload,
  type DocsSearchNavigation,
  type DocsSearchNavigationResolvers,
  type DocsSearchResult,
  getDocsPayloadSourceTypes,
  getDocsSearchLocationIdentity,
  isDocsPdfPagePayload,
  openDocsSearchNavigation,
  type OpenDocsSearchNavigationOptions,
  type PdfPageSearchHit,
} from './services/source-navigation';
export {
  WARM_CACHE_DEFAULT_BUDGET_BYTES,
  WarmCacheService,
} from './services/warm-cache';

import { type Framework } from '@toeverything/infra';

import { WorkspaceServerService } from '../cloud';
import { DocsService } from '../doc';
import { FavoriteService } from '../favorite';
import { PermissionSnapshotStore } from '../permissions';
import { WorkspaceQuotaService } from '../quota';
import {
  WorkspaceLocalCache,
  WorkspaceLocalState,
  WorkspaceScope,
  WorkspaceService,
  WorkspacesService,
} from '../workspace';
import { DocsSearchService } from './services/docs-search';
import { SearchPartitionSyncService } from './services/search-partition-sync';
import { WarmCacheService } from './services/warm-cache';

export function configureDocsSearchModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .service(DocsSearchService, [
      WorkspaceService,
      DocsService,
      WorkspaceServerService,
      PermissionSnapshotStore,
      WorkspaceLocalCache,
    ])
    .service(WarmCacheService, [
      WorkspaceService,
      WorkspacesService,
      WorkspaceServerService,
      WorkspaceQuotaService,
      WorkspaceLocalState,
      DocsService,
      FavoriteService,
    ])
    .service(SearchPartitionSyncService, [
      WorkspaceService,
      WorkspaceServerService,
      DocsService,
      WarmCacheService,
      WorkspaceLocalState,
      DocsSearchService,
    ]);
}
